import create from 'blop/state'

type State = {
  dogPage: { score: number, attempt: number, success: number,
    choice: { breed: string, url: string, image: string },
    lastResult: any
  },
  petStore: { pets: string[], pageIndex: number },
  route: { name: string, params: object, loading: boolean },
  memes: string[],
  todoList: { text: string, completed: boolean, id: number }[]
}

state: State = {
  dogPage: { score: 0, attempt: 0, success: 0,
    choice: { breed: '', url: '', image: '' },
    lastResult: undefined
  },
  todoList: [
  { text: 'Buy some milk', completed: false, id: 1 },
{ text: 'Take out the trash', completed: false, id: 2 },
{ text: 'Recycle', completed: false, id: 3 }
  ],
  petStore: { pets: [], pageIndex: 0 },
  route: { name: '', params: {}, loading: false },
  memes: []
}

def createState() { // the type will be different than State (extra $)
  return create(state)
}
